import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import logo from "../asseets/logo.png";

const Calculator = () => {
  const [cases, setCases] = useState("");
  const [containerSize, setContainerSize] = useState("");
  const [hazardousWaste, setHazardousWaste] = useState(15);
  const [laboratoryStaff, setLaboratoryStaff] = useState(45);
  const [warehouseCost, setWarehouseCost] = useState(20);
  
  const [isDisabled, setIsDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [region, setregion] = useState("EU");
  const [periods, setPeriods] = useState("");
  const [hasCalculated, setHasCalculated] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  
  const [euContainerSize, setEuContainerSize] = useState(""); // for EU
  const [namContainerSize, setNamContainerSize] = useState(""); // for NAMA + NAMB

  const [result, setResult] = useState({
    labourHour: null,
    materialWaste: null,
    totalSavings: null,
  });
  const [errors, setErrors] = useState({
    cases: "",
    containerSize: "",
    hazardousWaste: "",
    laboratoryStaff: "",
    warehouseCost: "",
    period: "",
    name: "",
    email: "",
  });

  useEffect(() => {    
  

    if (region === "EU") {
      setLaboratoryStaff(45);
      setWarehouseCost(20);
      setHazardousWaste(15);
      
    // Restore last EU container size
    setContainerSize(euContainerSize);

    } else {
      setLaboratoryStaff(35);
      setWarehouseCost(27);
      setHazardousWaste(9.33);
      
    // Restore last NAM size or default to 56
    setContainerSize(namContainerSize || "56");

    }
  }, [region]);

  
const materialUnit = region === "EU" ? "kg" : "lbs";
const formattedMaterialWaste = Number(result.materialWaste).toLocaleString();


const isEU = region === "EU";

const currencyLabel = isEU ? "Euros" : "USD";
const currencySymbol = isEU ? "€" : "$";
const formattedTotalSavings = Number(result.totalSavings).toLocaleString();
/* APi Base url */
const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiRegion = region === "EU" ? "EU" : "NAM";

  const callApi = async () => {
    try {
      const response = await fetch(`/rccc/calculate?region=${apiRegion}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          noOfCases: Number(cases),
          containerSize: Number(containerSize),
          disposelCost: Number(hazardousWaste),
          laborCostPerCase: Number(laboratoryStaff),
          warehousePerCase: Number(warehouseCost),
          period: String(periods),
          region: region,
        }),
      });
      console.log("response-region", response);
      if (!response.ok) {
        throw new Error("API returned an error");
      }
      const data = await response.json();
      setResult({
        labourHour: data.hoursSaved,
        materialWaste: data.materialsSaved,
        totalSavings: data.totalSaving,
      });
      console.log("data-result", data);
    } catch (error) {
      console.log("Calculate failed", error);
    }
  };
  const handleCalculate = async () => {
    
    let valid = true;
    // Clear previous errors before checking new inputs
    setErrors({ cases: "", containerSize: "" });

    if (!cases || isNaN(cases) || cases <= 0) {
      valid = false;
      setErrors((prevErrors) => ({
        ...prevErrors,
        cases: "Please enter a valid number of cases.",
      }));
    }
    if (!containerSize || isNaN(containerSize) || containerSize <= 0) {
      valid = false;
      setErrors((prevErrors) => ({
        ...prevErrors,
        containerSize: "Please enter a valid container size.",
      }));
    }
    if (!hazardousWaste || isNaN(hazardousWaste) || hazardousWaste <= 0) {
      valid = false;
      setErrors((prevErrors) => ({
        ...prevErrors,
        hazardousWaste: "Enter the valid cost (in €)",
      }));
    }
    if (!laboratoryStaff || isNaN(laboratoryStaff) || laboratoryStaff <= 0) {
      valid = false;
      setErrors((prevErrors) => ({
        ...prevErrors,
        laboratoryStaff: "Enter the valid cost (in €)",
      }));
    }
    if (!warehouseCost || isNaN(warehouseCost) || warehouseCost <= 0) {
      valid = false;
      setErrors((prevErrors) => ({
        ...prevErrors,
        warehouseCost: "Enter the valid cost (in €)",
      }));
    }
    if (!name || name.trim() === "") {
      valid = false;
      setErrors((prevErrors) => ({
        ...prevErrors,
        name: "Enter the name",
      }));
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    if (!email || !emailRegex.test(email.trim())) {
      valid = false;
      setErrors((prev) => ({
        ...prev,
        email: "Enter a valid email address",
      }));
    }

    if (!valid) {
      return;
    }
    
  
    try {
        setLoading(true); // ✅ SET LOADING TRUE

        await callApi(); // ✅ This WILL run now
        setHasCalculated(true);

      } catch (err) {
        console.error("Calculation failed", err);
      } finally {
        setLoading(false); // ✅ ALWAYS EXECUTES
      }

  };

  useEffect(() => {
    if (hasCalculated) {
      callApi();
    }
  }, [
    cases,
    containerSize,
    periods,
    hazardousWaste,
    laboratoryStaff,
    warehouseCost,
  ]);

 


 
  const handleReset = () => {
    setCases("");
    setContainerSize("");
     if (region === "EU") {
      setLaboratoryStaff(45);
      setWarehouseCost(20);
      setHazardousWaste(15);
      
    // Restore last EU container size
    setContainerSize(euContainerSize);

    } else {
      setLaboratoryStaff(35);
      setWarehouseCost(27);
      setHazardousWaste(9.33);
    }
    setPeriods("");
    setName("");
    setEmail("");
    setResult({
      labourHour: null,
      materialWaste: null,
      totalSavings: null,
    });
    setErrors({
      cases: "",
      containerSize: "",
      hazardousWaste: "",
      laboratoryStaff: "",
      laboratoryStaffNAM: "",
      warehouseCost: "",
      warehouseCostNAM: "",
      name: "",
      email: "",
    });
    setIsDisabled(false);
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(`/rccc/download?region=${apiRegion}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          noOfCases: Number(cases),
          containerSize: Number(containerSize),
          disposelCost: Number(hazardousWaste),
          laborCostPerCase: Number(laboratoryStaff),
          warehousePerCase: Number(warehouseCost),
          period: String(periods),
          name: String(name),
          emailId: String(email),
        }),
      });
      //if APi fails
      if (!response.ok) {
        throw new Error("API returned an error");
      }
      //   //API will return a file

      const cd = response.headers.get("Content-Disposition") || "";
      const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(cd);
      const filename = match
        ? decodeURIComponent(match[1])
        : "Cost_Saving_Calculations_";

      // Get the PDF as a blob
      const blob = await response.blob();
      console.log("blob size:", blob.size, "type:", blob.type); // should be application/pdf

      const url = window.URL.createObjectURL(blob);

      // Create temporary <a> and download
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      // Cleanup
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Something went wrong while downloading the file.");
    }
  };

  const handleSendEmail = async () => {
    try {
      setLoading(true);

      const response = await fetch(`/rccc/send?region=${apiRegion}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          noOfCases: Number(cases),
          containerSize: Number(containerSize),
          disposelCost: Number(hazardousWaste),
          laborCostPerCase: Number(laboratoryStaff),
          warehousePerCase: Number(warehouseCost),
          period: String(periods),
          name: String(name),
          emailId: String(email),
        }),
      });
      const result = await response.text();
      if (response.ok) {
        alert("Email sent successfully");
      } else {
        throw new Error("API returned an error" + result);
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Something went wrong while sending the file.");
    }
  };

  const sizeOption = {
    EU: [
      { value: "7", label: "7L" },
      { value: "18", label: "18L" },
      { value: "45", label: "45L" },
    ],
    NAMA: [
      { value: "56", label: "56L" },
      { value: "200", label: "200L" },
      { value: "1100", label: "1100L" },
    ],
    NAMB: [
      { value: "56", label: "56L" },
      { value: "200", label: "200L" },
      { value: "1100", label: "1100L" },
    ],
  };

  return (
    <div className="container-fluid vh-100 calculator-container">
      <div className="row h-100 align-items-stretch">
        {/* LEFT IMAGE (30%) */}
        <div className="col-lg-5 p-0 d-flex image-col image-wrapper">
          <div className="image-overlay"></div>
          <img
            src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f"
            alt="Background"
            className="img-fluid image-fill"
          />

          <div className="content-overlay-content card w-100">
            <div className="card-body">
              <p className="card-text">
                The <b>Returnable Container Cost Calculator</b> is designed to
                help customers visualize and understand the costs and cardboard
                packaging savings they can achieve by transitioning from
                traditional glass bottles to returnable containers. Its main
                function is to calculate and compare the costs associated with
                handling glass bottles and their packaging versus returning a
                container, clearly highlighting the financial and environmental
                benefits of adopting the returnable container model.
              </p>
            </div>
          </div>
          <div className="overlay-content">
            <h3 className="fw-bold text-center">COST SAVINGS CALCULATOR</h3>
            <p className="mb-0 text-center">
              {" "}
              Transition From Glass Bottles to Returnable Containers & Save!
            </p>
          </div>
        </div>

        {/* RIGHT FORM (70%) */}
        <div className="col-lg-7 d-flex align-items-center justify-content-center bg-light position-relative">
          <div className="form-overlay"></div>
          <div className="w-100 z-index-2">
            <div className="mb-4 mt-3 text-center">
              <h3 className="fw-bold text-white heading">
                RETURNABLE CONTAINER COST CALCULATOR
              </h3>
            </div>

            <form className="form-container px-3 py-2 mb-3 px-sm-5 py-sm-3 background-grey">
              <div className="d-flex justify-start-end my-1">
                <img src={logo} className="solstice-logo" alt ="Solstice Logo"/>
              </div>
              <div className="d-flex justify-content-end my-3">
                <select
                  className="form-select w-auto"
                  value={region}
                  onChange={(e) => setregion(e.target.value)}
                >
                  <option value="EU">EU Model (€) - Incl. Hazardous Waste Disposal for Bottles</option>
                  <option value="NAMA">NAM Model A ($) - Incl. Hazardous Waste Disposal for Bottles</option>
                  <option value="NAMB">NAM Model B ($) - Double Rinse Empty Bottles Under Vented Hood​</option>
                </select>
              </div>

              {/* Enter the name" */}
              <div className="mb-3 position-relative">
                <label
                  htmlFor="name"
                  className="form-label text-white text-start d-block"
                >
                  {region === "EU"
                    ? "Enter your name"
                    : "Enter your name"}
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  id="name"
                  placeholder={
                    region === "EU" ? "Enter Name " : "Enter Name"
                  }
                  value={name}
                 
                  onChange={(e) => {
                      setName(e.target.value);
                      if (e.target.value.trim()) {
                        setErrors((prev) => ({ ...prev, name: "" }));
                      }
                    }}

                />
                
                {errors.name && (
                  <div className="invalid-feedback">{errors.name}</div>
                )}
              </div>

              {/* Enter the emailId" */}
              <div className="mb-3 position-relative">
                <label
                  htmlFor="emailId"
                  className="form-label text-white text-start d-block"
                >
                  {region === "EU"
                    ? "Enter your email"
                    : "Enter your email"}
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  id="emailId"
                  placeholder={
                    region === "EU" ? "Enter Email " : "Enter Email"
                  }
                  value={email}
                 
                 onChange={(e) => {
                  const value = e.target.value;
                  setEmail(value);

                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

                  if (!value.trim()) {
                    setErrors((prev) => ({
                      ...prev,
                      // email: "Email is required",
                    }));
                  } else if (!emailRegex.test(value.trim())) {
                    setErrors((prev) => ({
                      ...prev,
                      email: "Enter a valid email address",
                    }));
                  } else {
                    setErrors((prev) => ({
                      ...prev,
                      email: "",
                    }));
                  }
                }}

                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>

              {/* Label & Number Input for "Cases" */}
              <div className="mb-3 position-relative">
                <label
                  htmlFor="cases"
                  className="form-label text-white text-start d-block"
                >
                  {region === "EU"
                    ? "Enter the number of cases (4 * 2.5L) you receive "
                    : region === "NAMA"
                      ? "Enter the number of cases (4 * 4L) you receive"
                      : "Enter the number of cases (4 * 4L) you receive"}
                </label>
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="number"
                    className={`form-control ${errors.cases ? "is-invalid" : ""}`}
                    id="cases"
                    placeholder={
                      region === "EU"
                        ? "Enter the number of cases"
                        : region === "NAMA"
                          ? "Enter number "
                          : "Enter number "
                    }
                    value={cases}
                    onChange={(e) => {
                      setCases(e.target.value);
                      if (e.target.value) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          cases: "",
                        }));
                      }
                    }}
                  />
                  <select
                    className="form-select w-auto"
                    value={periods}
                    onChange={(e) => setPeriods(e.target.value)}
                  >
                    <option value="year">year</option>
                    <option value="month">month</option>
                    <option value="week">week</option>
                  </select>
                </div>

                {errors.cases && (
                  <div className="invalid-feedback">{errors.cases}</div>
                )}
              </div>

              {/* Label & Number Input for "Container Size" */}
              <div className="mb-3 position-relative">
                <label
                  htmlFor="containerSize"
                  className="form-label text-white text-start d-block"
                >
                  {region === "EU"
                    ? "Container size in L"
                    : region === "NAMA"
                      ? "Container size in L "
                      : "Container size in L "}
                </label>
                <select
                  id="containerSize"
                  className={`form-control ${errors.containerSize ? "is-invalid" : ""}`}
                  value={containerSize}
                  onChange={(e) => {
                    const value = e.target.value;
                    setContainerSize(value); // UI + API

                    if (region === "EU") {
                      setEuContainerSize(value);     // remember EU value
                    } else {
                      setNamContainerSize(value);    // remember NAM value
                    }

                    if (e.target.value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        containerSize: "",
                      }));
                    }
                  }}
                >
                  <option value="">Select size in L</option>
                  {sizeOption[region].map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
                {errors.containerSize && (
                  <div className="invalid-feedback">{errors.containerSize}</div>
                )}
              </div>

              {/* Label & Number Input for "Cost of Disposing Hazardous Waste, Box and Insert, Bottles" */}
              {region !== "NAMB" && (
              <div className="mb-3 position-relative">
                <label
                  htmlFor="hazardousWaste"
                  className="form-label text-white text-start d-block"
                >
                  {region === "EU"
                    ? "Cost of Disposing Hazardous Waste, Box and Insert, Bottles in EURO"
                    : "Cost per case for double rinse of bottles under vent hood in USD"}
                </label>
                <input
                  type="number"
                  className={`form-control ${errors.hazardousWaste ? "is-invalid" : ""}`}
                  id="hazardousWaste"
                  placeholder={
                    region === "EU"
                      ? "default value is €15.00 "
                      : "Enter number (NAM)"
                  }
                  value={hazardousWaste}
                  onChange={(e) => {
                    setHazardousWaste(e.target.value);
                  }}
                />
                {errors.hazardousWaste && (
                  <div className="invalid-feedback">
                    {errors.hazardousWaste}
                  </div>
                )}
              </div>
              )}
              {/* Label & Number Input for "Laboratory Staff" */}
              <div className="mb-3 position-relative">
                <label
                  htmlFor="laboratoryStaff"
                  className="form-label text-white text-start d-block"
                >
                  {region === "EU"
                    ? "Laboratory Staff in EURO"
                    : "Laboratory Staff Hourly Rate"}
                </label>
                <input
                  type="number"
                  className={`form-control ${errors.laboratoryStaff ? "is-invalid" : ""}`}
                  id="laboratoryStaff"
                  placeholder={
                    region === "EU"
                      ? "default value is €45.00 "
                      : "Enter number (NAM)"
                  }
                  value={laboratoryStaff}
                  onChange={(e) => {
                    setLaboratoryStaff(e.target.value);
                  }}
                />
                {errors.laboratoryStaff && (
                  <div className="invalid-feedback">
                    {errors.laboratoryStaff}
                  </div>
                )}
              </div>

              {/* Label & Number Input for "warehouse" */}
              <div className="mb-3 position-relative">
                <label
                  htmlFor="warehouse"
                  className="form-label text-white text-start d-block"
                >
                  {region === "EU"
                    ? "Warehouse Staff in EURO"
                    : "Warehouse Staff Hourly Rate"}
                </label>
                <input
                  type="number"
                  className={`form-control ${errors.warehouseCost ? "is-invalid" : ""}`}
                  id="warehouse"
                  placeholder={
                    region === "EU"
                      ? "Default value is 20.00 EURO "
                      : "Enter number USD"
                  }
                  value={warehouseCost}
                  onChange={(e) => {
                    setWarehouseCost(e.target.value);
                  }}
                />
                {errors.warehouseCost && (
                  <div className="invalid-feedback">{errors.warehouseCost}</div>
                )}
              </div>

              {/* Disabled Fields for Results */}
              {result.labourHour && (
                <>
                  <div className="mb-3">
                    <label
                      htmlFor="labourHour"
                      className="form-label text-white text-start d-block"
                    >
                      You could save {result.labourHour} Hours in Labor
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="labourHour"
                      value={result.labourHour}
                      disabled
                    />
                  </div>
                </>
              )}
           {result.materialWaste && (
                <div className="mb-3">
                  <label
                    htmlFor="materialWaste"
                    className="form-label text-white text-start d-block"
                  >
                    You could save {formattedMaterialWaste} {materialUnit} in material waste
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    id="materialWaste"
                    value={`${formattedMaterialWaste} ${materialUnit}`}
                    disabled
                  />
                </div>
              )}
              {result.totalSavings && (
                <div className="mb-3">
                  <label
                    htmlFor="totalSavings"
                    className="form-label text-white text-start d-block"
                  >
                   
                Meaning, you could save {formattedTotalSavings} {currencyLabel} in labor
                and material waste costs

                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="totalSavings"
                   value={`${currencySymbol} ${formattedTotalSavings}`}
                    disabled
                  />
                </div>
              )}

              {/* Buttons for Actions */}
              <div className="d-flex gap-2 mb-3">
                <button
                  className="btn btn-secondary w-50"
                  type="button"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  type="button"
                  className="btn btn-primary w-50"
                  onClick={handleCalculate}
                  disabled={loading}
                >
                {loading ? "Calculate" : "Calculate"}
                </button>
                {result.labourHour && (
                  <button
                    type="button"
                    className="btn btn-success w-50"
                    onClick={handleDownload}
                  >
                    Download
                  </button>
                )}
                {result.labourHour && (
                  <button
                    type="button"
                    className="btn btn-success w-50"
                    onClick={handleSendEmail}
                  >
                    Send PDF
                  </button>
                )}
              </div>

              <p className="text-muted small mt-3">
                {region === "EU" ? (
                  <ul>
                    <li>Time saved calculation based on 4 mins per case.</li>
                    <li>
                      One box weighing 1.57 Kgs and 4 2.5L bottles weighing 5.5
                      Kgs.
                    </li>
                    <li>
                      15€ per carton and bottles for hazardous waste disposal.
                    </li>
                    <li>45€ per hour for the cost of a QA chemist.</li>
                    <li>20€ per hour for the cost of warehouse staff.</li>
                  </ul>
                ) : (
                  <ul>
                   <li>Time saved calculation based on 4 mins per case.</li> 
                    <li>One box weighing 2.59 Pounds and 4 4L bottles weighing 0.95 Pounds.</li>
                    <li>$9.33 per carton and bottles for hazardous waste disposal.</li>
                    <li>$35 per hour for the cost of a QA chemist.</li>
                    <li>$27 per hour for the cost of warehouse staff.</li>
                  </ul>
                )}
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calculator;
